export default __webpack_public_path__ + "static/media/V4.7d295a65.svg";